module.exports = __webpack_public_path__ + "media/images/instructions/aws-iam-roles-4597c96b1278e9f4725773ca3e4e4ac6.png";